import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function beRijksRegisterNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const payload = control.value;
    if (typeof payload !== 'string')
      return { isRrn: { type: 'Rijksregisternumber should be a string' } };
    const normalized = payload.replace(/[.\-]/g, '');
    if (normalized.length !== 11)
      return { isRrn: { length: 'Rijksregisternumber should be 11 numbers' } };
    const data = parseInt(normalized.slice(0, 9));
    const modulo = parseInt(normalized.slice(9, 11));
    if (isNaN(data) || isNaN(modulo))
      return {
        isRrrn: { type: 'Rijksregisternumber is not a valid number string' },
      };
    const pre2000 = 97 - (data % 97);
    const post2000 = 97 - ((data + 2 * 10 ** 9) % 97);
    const checked = pre2000 === modulo || post2000 === modulo;
    return checked
      ? null
      : { isRrn: { modulo: 'Rijksregisternumber is invalid' } };
  };
}

export function isValidBeRrn(rrn: unknown) {
  if (typeof rrn !== 'string') return false;
  const normalized = rrn.replace(/[.\-]/g, '');
  if (normalized.length !== 11) return false;
  const data = parseInt(normalized.slice(0, 9));
  const modulo = parseInt(normalized.slice(9, 11));
  if (isNaN(data) || isNaN(modulo)) return false;

  const pre2000 = 97 - (data % 97);
  const post2000 = 97 - ((data + 2 * 10 ** 9) % 97);

  return pre2000 === modulo || post2000 === modulo;
}

export function sanitizeBeRrn(rrn: unknown) {
  if (typeof rrn !== 'string') throw new Error('Invalid be:rrn');
  const normalized = rrn.replace(/[.\-]/g, '');
  if (normalized.length !== 11) throw new Error('Invalid be:rrn');
  const data = parseInt(normalized.slice(0, 9));
  const modulo = parseInt(normalized.slice(9, 11));
  if (isNaN(data) || isNaN(modulo)) throw new Error('Invalid be:rrn');
  return (
    normalized.slice(0, 2) +
    '.' +
    normalized.slice(2, 4) +
    '.' +
    normalized.slice(4, 6) +
    '-' +
    normalized.slice(6, 9) +
    '.' +
    normalized.slice(9, 11)
  );
}
